import React from 'react'
import ReactDOM from 'react-dom'
import Root from './app/components/Root'
import configureStore from './app/store/configureStore'
import registerServiceWorker from './registerServiceWorker'

const store = configureStore()

const render = () => {
	ReactDOM.render(<Root store={store} />, document.getElementById('root'))
}

render()

if (module.hot) {
	module.hot.accept('./app/components/Root', () => {
		render()
	})
}

registerServiceWorker()
